import {toSafeInteger as _sint, get as _get, isEqual as _isEqual} from 'lodash';

const TS = require('@zerolight/zlthunder-time-utils');

const APIController = require('../../shared/api-controller');
const {apiCall, eventTypesAPICall} = require('../../shared/api-client');

import CentralConfigClient from '../../shared/central-config-client';
const {PROCESSING, SelfReloadingController} = require('./shared');

const config = require('../../shared/config');

const CUSTOMER_INFO_TEMPLATE = require('../../templates/customer-info.html');
const GENERATED_IMAGES_TYPE = ['2DODFrame', 'Complete'];

class CustomerInfo extends SelfReloadingController {
	constructor(options) {
		super(Object.assign({
			template: CUSTOMER_INFO_TEMPLATE,
			customerInfoEndpoint: 'dashboard/customer-info',
			eventsCountEndpoint: 'events/count',
			alertThreshold: 7200
		}, options));
		options = this.options;
		let ccClient = options.centralConfigClient;
		if (!ccClient) {
			let ccConfig = config.get('BillingConfiguration');
			if (ccConfig) {
				ccClient = new CentralConfigClient(ccConfig);
			}
		}
		this.centralConfigClient = ccClient;
	}

	static minutesFormatter(value) {
		if (value !== undefined) {
			return Math.round(_sint(value) / TS.MINUTE);
		} else {
			return PROCESSING;
		}
	}

	loadCentralConfig(options) {
		let ccConfig = config.get('BillingConfiguration');
		if (!ccConfig) {
			console.error("Central configuration client isn't configured", options);
			return {};
		}

		let ccClient = new CentralConfigClient(ccConfig);
		let fallback = ccConfig.fallbackConfiguration || {};
		return ccClient.get()
			.then(
				function (response) {
					let re = Object.assign({}, fallback);
					let {project} = response;
					if (project) {
						// Got the whole service configuration, pluck subProject if needed
						let {billingConfiguration, subProjects} = project;
						Object.assign(re, billingConfiguration);
						let {subProject} = ccConfig;
						if (subProject && subProjects) {
							Object.assign(re, _get(subProjects, `${subProject}.billingConfiguration`));
						}
						console.debug(re);
						return re;
					}
					// Legacy support for billingconfiguration helper
					return Object.assign(re, response.configuration);
				},
				function (err) {
					console.error(err);
					return fallback;
				}
			);
	}

	runApiCall(options) {
		// TODO: rewrite this
		let self = this;
		let re = {};
		return this.loadCentralConfig(options)
			.then(function (response) {
				re.centralConfig = response;
				let {showGeneratedImages, showCachedImages} = response;
				let {customerInfoEndpoint, eventsCountEndpoint} = options;
				let api = {
					imagesGenerated: undefined,
					imagesCached: undefined
				};
				let apiCalls = [];

				let customerInfoCall = apiCall(Object.assign(options, {method: customerInfoEndpoint}))
					.then(function (response) {
						console.debug(response);
						Object.assign(api, response.data);
					});

				apiCalls.push(customerInfoCall);
				if (showGeneratedImages) {
					let generatedImagesCall = eventTypesAPICall(Object.assign(
						options,
						{
							method: eventsCountEndpoint,
							params: {
								type: [GENERATED_IMAGES_TYPE],
								from: new Date('1970-01-01')
							}
						}
					))
						.then(function (response) {
							let data = response.data;
							api.imagesGenerated = data.get(GENERATED_IMAGES_TYPE, 'count');
						});
					apiCalls.push(generatedImagesCall);
				}

				return Promise.all(apiCalls).then(function () {
					re.api = api;
				});
			})
			.then(function () {
				return re;
			});
	}

	processResponse(response) {
		let {api} = response;
		if (api.stale) {
			response.stale = true;
		}
		return response;
	}

	getRenderOptions(options) {
		options = super.getRenderOptions(options);
		let {api, centralConfig} = options.data;
		let {life, day14, day7, stale} = api;
		let minutesUsed, minutesLast7Days, minutesPrevious7Days, allowance;
		let minutesPayed = centralConfig.limit3DMinutes;

		let minutesFormatter = CustomerInfo.minutesFormatter;
		if (stale) {
			console.warn('Customer info data is being calculated');
			// Let's just try to get some of them
			minutesUsed = minutesFormatter(life);
			minutesLast7Days = minutesFormatter(day7);
			minutesPrevious7Days = minutesFormatter(day14);
			allowance = undefined;
		} else {
			// 3D metrics and allowance
			minutesUsed = minutesFormatter(life);
			minutesLast7Days = minutesFormatter(day7);
			minutesPrevious7Days = minutesFormatter(day14);
			allowance = minutesPayed - minutesUsed;
		}

		// 2DoD metrics (NOTE! might be absent in response)
		let {limit2DGeneratedImages, limit2DCachedImages, showGeneratedImages, showCachedImages} = centralConfig;
		limit2DGeneratedImages = _sint(limit2DGeneratedImages);
		limit2DCachedImages = _sint(limit2DCachedImages);
		showGeneratedImages = Boolean(showGeneratedImages);
		let imagesGenerated, imagesCached;
		if (showGeneratedImages) {
			limit2DGeneratedImages = _sint(limit2DGeneratedImages);
			imagesGenerated = _sint(api.imagesGenerated);
		}
		if (showCachedImages) {
			limit2DCachedImages = _sint(limit2DCachedImages);
			imagesCached = _sint(api.imagesCached);
		}

		// let imagesBudget = limit2DGeneratedImages + limit2DCachedImages - imagesGenerated;

		let alertThreshold = centralConfig.notificationThreshold || options.alertThreshold;
		let ro = {
			template: options.template, container: options.container,
			allowance: allowance, minutesUsed: minutesUsed,
			minutesLast7Days: minutesLast7Days,
			minutesPrevious7Days: minutesPrevious7Days,
			imagesGenerated: imagesGenerated,
			imagesCached: imagesCached,
			imagesBudget: undefined,
			alertThreshold: alertThreshold,
			stale
		};

		if (allowance > 0) {
			let consumptionRate = minutesLast7Days / (7 * 24 * 60);
			let remainingMinutes = allowance / consumptionRate;
			if (remainingMinutes < alertThreshold) {
				ro.alert = 'warning';
			}
			ro.alertTime = new Date(_.now() + (remainingMinutes - alertThreshold) * TS.MINUTE);
		} else {
			ro.alert = 'alert';
		}
		console.debug(api, centralConfig, ro);
		return ro;
	}

	draw(options) {
		options = super.draw(options);
		let self = this;
		this.$.find('[data-processing]').click(function () {
			self.reload();
			return false;
		});
		return options;
	}
}

export default CustomerInfo;